<template>
  <div id="user-edit-tab-info">
    <div id="teacherTimeLoadingDiv" class="vs-con-loading__container">
      <!-- ADD CALENDAR CLASS -->
      <vs-popup  classContent="popup-example h-full" title="Schedule" :active.sync="activePromptAddSchulde">
        <div id="createTeacherSchudleLoadingDiv" class="vs-con-loading__container">
          <form data-vv-scope="createScheduleForm">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-tabs position="left" color="primary">
                  <vs-tab label="M">
                    <div class="vx-col w-11/12 ml-4 mb-base">
                      <div :key="index"  v-for="(item,index) in userSchedule.Monday">
                        <user-schedule-div day="Monday" :keyValue="index" :data="item"></user-schedule-div>
                      </div>

                      <div class="vx-row mb-base">
                        <div class="vx-col w-full">
                          <vs-button @click="addSchedule('Monday')" color="primary" class="w-full">Add a Schedule</vs-button>
                        </div>
                      </div>
                    </div>
                  </vs-tab>

                  <vs-tab label="T">
                    <div class="vx-col w-11/12 ml-4 mb-base">
                      <div class="vx-row mb-base">
                        <div class="vx-col w-full mb-2">
                          <ul class="demo-alignment">
                            <li>
                              <vs-checkbox @input="repeatCheckBox('Tuesday')" v-model="sameSchedule.Tuesday">Repeat the schedule as Monday/First day</vs-checkbox>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div :key="index"  v-for="(item,index) in userSchedule.Tuesday">
                        <user-schedule-div day="Tuesday" :keyValue="index" :data="item"></user-schedule-div>
                      </div>
                    </div>

                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <vs-button  @click="addSchedule('Tuesday')" color="primary" class="w-full">Add a Schedule</vs-button>
                      </div>
                    </div>
                  </vs-tab>
                  <vs-tab label="W">
                    <div class="vx-col w-11/12 ml-4 mb-base">
                      <div class="vx-row mb-base">
                        <div class="vx-col w-full mb-2">
                          <ul class="demo-alignment">
                            <li>
                              <vs-checkbox @input="repeatCheckBox('Wedneday')" v-model="sameSchedule.Wedneday">Repeat the schedule as Monday/First day</vs-checkbox>
                            </li>
                          </ul>
                        </div>
                      </div>
    
                      <div :key="index"  v-for="(item,index) in userSchedule.Wedneday">
                        <user-schedule-div day="Wedneday" :keyValue="index" :data="item"></user-schedule-div>
                      </div>

                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <vs-button  @click="addSchedule('Wedneday')" color="primary" class="w-full">Add a Schedule</vs-button>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                  <vs-tab label="T">
                    <div class="vx-col w-11/12 ml-4 mb-base">
                      <div class="vx-row mb-base">
                        <div class="vx-col w-full mb-2">
                          <ul class="demo-alignment">
                            <li>
                              <vs-checkbox @input="repeatCheckBox('Thursday')" v-model="sameSchedule.Thursday">Repeat the schedule as Monday/First day</vs-checkbox>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div :key="index"  v-for="(item,index) in userSchedule.Thursday">
                        <user-schedule-div day="Thursday" :keyValue="index" :data="item"></user-schedule-div>
                      </div>

                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <vs-button  @click="addSchedule('Thursday')" color="primary" class="w-full">Add a Schedule</vs-button>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                  <vs-tab label="F">
                    <div class="vx-col w-11/12 ml-4 mb-base">
                      <div class="vx-row mb-base">
                        <div class="vx-col w-full mb-2">
                          <ul class="demo-alignment">
                            <li>
                              <vs-checkbox @input="repeatCheckBox('Friday')" v-model="sameSchedule.Friday">Repeat the schedule as Monday/First day</vs-checkbox>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div :key="index"  v-for="(item,index) in userSchedule.Friday">
                        <user-schedule-div day="Friday" :keyValue="index" :data="item"></user-schedule-div>
                      </div>

                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <vs-button  @click="addSchedule('Friday')" color="primary" class="w-full">Add a Schedule</vs-button>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                  <vs-tab label="S">
                    <div class="vx-col w-11/12 ml-4 mb-base">
                      <div class="vx-row mb-base">
                        <div class="vx-col w-full mb-2">
                          <ul class="demo-alignment">
                            <li>
                              <vs-checkbox @input="repeatCheckBox('Saturday')" v-model="sameSchedule.Saturday">Repeat the schedule as Monday/First day</vs-checkbox>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div :key="index"  v-for="(item,index) in userSchedule.Saturday">
                        <user-schedule-div day="Saturday" :keyValue="index" :data="item"></user-schedule-div>
                      </div>

                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <vs-button  @click="addSchedule('Saturday')" color="primary" class="w-full">Add a Schedule</vs-button>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                  <vs-tab label="S">
                    <div class="vx-col w-11/12 ml-4 mb-base">
                      <div class="vx-row mb-base">
                        <div class="vx-col w-full mb-2">
                          <ul class="demo-alignment">
                            <li>
                              <vs-checkbox @input="repeatCheckBox('Sunday')" v-model="sameSchedule.Sunday">Repeat the schedule as Monday/First day</vs-checkbox>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div :key="index"  v-for="(item,index) in userSchedule.Sunday">
                        <user-schedule-div day="Sunday" :keyValue="index" :data="item"></user-schedule-div>
                      </div>

                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <vs-button  @click="addSchedule('Sunday')" color="primary" class="w-full">Add a Schedule</vs-button>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                </vs-tabs>

                <div class="vx-row mb-4 ml-4" style="height: 300px;">
                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <small class="date-label">Start Date</small>
                    <datepicker v-validate="'required|after:'+currentDate+'|date_format:yyyy-MM-dd'" name="startDate" ref="startDate" format="yyyy-MM-dd" :disabledDates="disabledDates" v-model="startDate" ></datepicker>
                    <span class="text-danger text-sm" v-show="errors.has('createScheduleForm.startDate')">{{ errors.first('createScheduleForm.startDate') }}</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full mb-2">
                    <small class="date-label">End Date</small>
                    <datepicker v-validate="'required|after:'+currentDate+'|date_format:yyyy-MM-dd'" name="endDate" ref="endDate" format="yyyy-MM-dd" :disabledDates="disabledDates" v-model="endDate"></datepicker>
                    <span class="text-danger text-sm" v-show="errors.has('createScheduleForm.endDate')">{{ errors.first('createScheduleForm.endDate') }}</span>
                  </div>
                </div>

                <vs-divider class="ml-8"/>

                <div class="vx-row">
                  <div class="vx-col w-full" style="margin-left: 4rem !important;" align="right">
                    <vs-button @click="validateCreateScheduleForm()" class="mb-2">Save Schedule</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </vs-popup>
      
      

      <div class="vx-row mb-base">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-for="(schedule,index) in schedules">
          <div class="m-2">
            <vx-card >
              <div slot="no-body">

              </div>
              <h5 class="mb-2">{{ getScheludeTiTle(schedule)}}</h5>
              <br>
              <div v-for="(days,indexx) in schedule.days" class="mb-2">
                <p class="text-grey">{{ days[0] }}</p>
                <div v-for="(slots,indexxx) in days[1]" class="p-1 mb-1" style="background-color: #D8D9D9;border-left: 3px solid  #00A99D;">
                  <p class="text-black">{{ slots.time_from+" - "+slots.time_to+" ("+slots.hours+"Min)"}}</p>
                </div>
              </div>
              
              <div class="vx-row m-0">
                <div class="vx-col pl-0 w-6/12">
                  <vs-button class="w-full" color="#2d2d3c" type="filled" icon-pack="feather" icon="icon-trash" @click="deleteOneSchedule(schedule)"></vs-button>
                </div>
                <div class="vx-col p-0 w-6/12">
                  <vs-button class="w-full" color="primary" type="filled" icon-pack="feather" icon="icon-edit" @click="editOneSchedule(schedule)"></vs-button>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full" align="right">
          <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="addNewSchedule()">Add a Schedule</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from "vuejs-datepicker/src/locale"
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import userScheduleDiv from "./UserScheduleDiv.vue"

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    userScheduleDiv,
    Datepicker,
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      checkBox1: false,
      signatureImage: null,
      signatureImageData: {
        songs: [],
        image : '',
        imgURL : '',
      },
      userSchedule : {
        // Monday : [ { time_from: "00:00", hours: 45, type: "work" }],
        Monday : [],
        Tuesday : [],
        Wedneday : [],
        Thursday : [],
        Friday : [],
        Saturday : [],
        Sunday : [],
      },
      sameSchedule : {
        Monday : false,
        Tuesday : false,
        Wedneday : false,
        Thursday : false,
        Friday : false,
        Saturday : false,
        Sunday : false,
      },
      startDate: '',
      endDate: '',
      schedules : [],
      activePromptAddSchulde : false,
      addEditSchldeType : "create",
      deleteScheduleData : null,
      currentDate : new Date().toISOString().substring(0, 10),
      disabledDates : { 
        to: new Date(),
        // from: new Date()
      }
    }
  },
  computed: {
    // currentDate(){
    //   var today = new Date();
    //   return today.toISOString().substring(0, 10);
    // },
    // startDate(){
    //   var today = new Date();
    //   return today.toISOString().substring(0, 10);
    // },
    // endDate(){
    //   var today = new Date();
    //   return today.toISOString().substring(0, 10);
    // },
    validateForm() {
      return !this.errors.any()
    },
    // disabledDatesTo() {
    //   return { to: new Date() }
    // },
    // disabledDatesFrom() {
    //   return { from: new Date() }
    // },
  },
  methods: {
    repeatCheckBox(day) {
      this.userSchedule[day] = this.userSchedule.Monday
    },
    getScheludeTiTle(schedule) {
      if(schedule.days != null && schedule.days.length > 0){
        if(schedule.days[0][1] != null && schedule.days[0][1].length > 0){
          if(schedule.days[0][1][0].title != null) return schedule.days[0][1][0].title;
        }
      }

      return schedule.date_from+" to "+ schedule.date_to;
    },
    removeSchedule(day, index) {
      this.userSchedule[day].splice(index, 1)
      // this.userSchedule[day] = this.userSchedule[day].splice(index, 1);
    },
    addMinutes(time, minsToAdd) {
      function D(J){ return (J<10? '0':'') + J;};
      var piece = time.split(':');
      var mins = piece[0]*60 + +piece[1] + +minsToAdd;

      return D(mins%(24*60)/60 | 0) + ':' + D(mins%60);  
    },
    addSchedule(day){
      if(this.userSchedule[day].length){
        let lastSchedule = this.userSchedule[day][(this.userSchedule[day].length - 1)]

        var newSchedule = {
          time_from : this.addMinutes(lastSchedule.time_from, lastSchedule.hours),
          time_to : this.addMinutes(this.addMinutes(lastSchedule.time_from, lastSchedule.hours), 45),
          hours : 45,
          type: "work",
        }
      }
      else{
        var newSchedule = { time_from: "00:00", hours: 45, type: "work" }
      }
      
      this.userSchedule[day].push(newSchedule)
    },
    validateCreateScheduleForm() {
      this.$validator.validateAll('createScheduleForm').then(result => {
        if (result) this.createSchedule()
        // else console.log(this.errors)
      })
    },
    async createSchedule(){
      this.$vs.loading({
        container: '#createTeacherSchudleLoadingDiv',
        scale: 0.6
      })

      var days = []
      var times = []
      var daysName = [
        { name : 'Monday', key : 'MON' },
        { name : 'Tuesday', key : 'TUE' },
        { name : 'Wedneday', key : 'WED' },
        { name : 'Thursday', key : 'THU' },
        { name : 'Friday', key : 'FRI' },
        { name : 'Saturday', key : 'SAT' },
        { name : 'Sunday', key : 'SUN' },
      ]

      for (const [day, userDaySchedule] of Object.entries(this.userSchedule)) {
        if(userDaySchedule.length){
          let dayKey = daysName.findIndex(x => x.name === day);
          days.push(daysName[dayKey].key)
          times.push(userDaySchedule)
        }

        // userDaySchedule.forEach(function(entry) {
        //   console.log(entry);
        // });
      }

      let data = {
        teacher_id : this.data_local.id,
        date_from : new Date(this.startDate).toISOString().slice(0, 10),
        date_to : new Date(this.endDate).toISOString().slice(0, 10),
        times : times,
        day : days,
        type : this.addEditSchldeType,
      }

      await this.$store.dispatch("userManagement/createTeacherTime", data)
        .then(res => { 
          // console.log(res)

          this.$vs.notify({
            title: "Success.",
            text: "Times created successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          this.$vs.loading.close('#createTeacherSchudleLoadingDiv > .con-vs-loading')
        })
        .catch(err => {
          // console.log(err)
          this.$vs.loading.close('#createTeacherSchudleLoadingDiv > .con-vs-loading')

          if(err.status && err.status == 500 && err.data.error_in && err.data.error_in.length){

            var errorMessage = "";
            for(var i = 0; i < err.data.error_in.length; i++){
              errorMessage = errorMessage + ""+err.data.error_in[i]["day"]+" : "+err.data.error_in[i]["time_from"]+" to "+err.data.error_in[i]["time_to"]+"<br>"
            }

            this.$vs.notify({
              title: 'You already have some time slots within flowing days',
              text: errorMessage,
              color: 'danger',
              fixed: true,
              click: () => {
                  // Secondary function
                  // this.$vs.notify({
                  //     title: 'Secondary function',
                  //     text: 'Executed the function when clicking',
                  //     color: 'success',
                  //     iconPack: 'feather',
                  //     icon: 'icon-check'
                  // })
              },
            })
          }
        })

      await this.$store.dispatch("userManagement/fetchTeacherTime", this.data_local.id)
        .then(res => { 
          this.schedules = res.data
        })
        .catch(err => {

        })
    },
    addNewSchedule(){
      var currentDate = new Date();
      var dateToDate = currentDate.setDate(currentDate.getDate() + 30);

      this.disabledDates = {
        to: new Date(),
        from : null,
      }

      this.startDate = Date.now()
      this.endDate = new Date(dateToDate)

      this.userSchedule = {
        Monday : [],
        Tuesday : [],
        Wedneday : [],
        Thursday : [],
        Friday : [],
        Saturday : [],
        Sunday : [],
      };

      this.addEditSchldeType = "create"
      this.activePromptAddSchulde = true
    },
    editOneSchedule(schedule){
      this.startDate = Date.parse(schedule.date_from)
      this.endDate = Date.parse(schedule.date_to)
      this.currentDate = schedule.date_from
      this.disabledDates = {
        to: new Date(schedule.date_from),
        from : null,
      }

      var daysName = [
        { name : 'Monday', key : 'MON' },
        { name : 'Tuesday', key : 'TUE' },
        { name : 'Wedneday', key : 'WED' },
        { name : 'Thursday', key : 'THU' },
        { name : 'Friday', key : 'FRI' },
        { name : 'Saturday', key : 'SAT' },
        { name : 'Sunday', key : 'SUN' },
      ]

      for (const [index, userDaySchedule] of Object.entries(schedule.days)) {
        let dayKey = daysName.findIndex(x => x.key === userDaySchedule[0]);
        this.userSchedule[daysName[dayKey].name] = userDaySchedule[1]
      }

      this.addEditSchldeType = "update"
      this.activePromptAddSchulde = true
    },
    async deleteOneSchedule(schedule){
      this.deleteScheduleData = schedule
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure to comfirm to delete this Schedule ?',
        accept: this.acceptDeleteSchedule
      })
    },
    async acceptDeleteSchedule(){
      this.$vs.loading({
        container: '#teacherTimeLoadingDiv',
        scale: 0.6
      })

      var teacherBookingId = [];
      var oneSchedule = this.deleteScheduleData;

      for(var i = 0; i < oneSchedule['days'].length; i++){
        for(var j = 0; j < oneSchedule['days'][i][1].length; j++){
          teacherBookingId.push(oneSchedule['days'][i][1][j]['id'].toString());
        }
      }

      var data = { 
        "teacher_booking_id" : teacherBookingId,
        "teacher_id" : this.data_local.id,
      };

      await this.$store.dispatch("userManagement/deleteTeacherTime", data)
        .then(res => { 
          // console.log(res)

          this.$vs.notify({
            title: "Success.",
            text: "Times deleted successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          this.$vs.loading.close('#teacherTimeLoadingDiv > .con-vs-loading')
        })
        .catch(err => {
          // console.log(err)
          this.$vs.loading.close('#teacherTimeLoadingDiv > .con-vs-loading')
        })

      await this.$store.dispatch("userManagement/fetchTeacherTime", this.data_local.id)
        .then(res => { 
          this.schedules = res.data
        })
        .catch(err => {

        })
    },
    fetchTeacherTime() {
      this.$vs.loading({
        container: '#teacherTimeLoadingDiv',
        scale: 0.6
      })

      this.$store.dispatch("userManagement/fetchTeacherTime", this.data_local.id)
        .then(res => { 
          this.schedules = res.data
          // this.startDate = Date.parse(res.data.date_from)
          // this.endDate = Date.parse(res.data.date_to)

          // var daysName = [
          //   { name : 'Monday', key : 'MON' },
          //   { name : 'Tuesday', key : 'TUE' },
          //   { name : 'Wedneday', key : 'WED' },
          //   { name : 'Thursday', key : 'THU' },
          //   { name : 'Friday', key : 'FRI' },
          //   { name : 'Saturday', key : 'SAT' },
          //   { name : 'Sunday', key : 'SUN' },
          // ]

          // for (const [index, userDaySchedule] of Object.entries(res.data.days)) {
          //   let dayKey = daysName.findIndex(x => x.key === userDaySchedule[0]);
          //   this.userSchedule[daysName[dayKey].name] = userDaySchedule[1]
          // }

          this.$vs.loading.close('#teacherTimeLoadingDiv > .con-vs-loading')
        })
        .catch(err => {
          this.$vs.loading.close('#teacherTimeLoadingDiv > .con-vs-loading')
        })
    },
  },
  created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
  },
  async mounted() {
    await this.$root.$on('removeScheduleParentComponent', (day, index) => {
      this.removeSchedule(day, index)
    });

     this.fetchTeacherTime()
  },
  beforeDestroy() {
    
  }
}
</script>

<style type="text/css">

.customTimeDiv{
  margin: 0px;
  border: 1px solid #dadada;
  padding-top: 10px;
  border-radius: 5px;
}

.customTimeDivCloseBtn{
  position: relative;
  bottom: 15px;
  left: 30px;
}

.vdp-datepicker__calendar{
  position: absolute;
  top: -282px;
}
</style>